import { Stack } from "@mui/material";
import { InformationSectionTextContent } from "@src/appV2/redesign/system/ui-components";

interface WorkBadgeRequiredSectionProps {
  workBadgeEnforcementEnabled: boolean;
}

export function WorkBadgeRequiredSection(props: WorkBadgeRequiredSectionProps) {
  const { workBadgeEnforcementEnabled } = props;

  return (
    <Stack spacing={5}>
      <InformationSectionTextContent>
        This workplace requires all professionals to wear a badge while working. It must be visible
        to workplace staff and residents and include your name, role, and a photo of your face.
      </InformationSectionTextContent>
      {workBadgeEnforcementEnabled && (
        <InformationSectionTextContent>
          You&apos;ll submit a photo of it attached to your work attire in the Clipboard app before
          you start your shift.
        </InformationSectionTextContent>
      )}
    </Stack>
  );
}
